export class BgcQuestionnaireRequest {
  'Group Id': string = '';
  'Email': string = '';
  'SR Number': string = '';
  'Expiry Date': string = '';
  'DC Requestor Name': string = '';
  'DC Requestor Email': string = '';
  'DC Requestor Phone Number': string = '';
  'DC Company Name': string = '';
  'DC Trade License Number': string = '';
  'DC Position': string = '';
  'Board Positions': string[] = [];
}
